/**
 * Represenation of a Member object.
 * @constructor
 * @extends {Foundation.Object}
 * @param {string=} oid
 */
Foundation.Member = function (oid) {
    Foundation.Object.call(this, "Member", oid);
};
Foundation.inherit(Foundation.Member, Foundation.Object);

/**
 * Set the fallback usernames to use if the first is already taken when
 * creating a new Member object.
 * @param {Array.<string>} userNames
 */
Foundation.Member.prototype.setFallbackUserNames = function (userNames) {
    this.set("fallbackUserName", userNames);
};

/**
 * Retreive a setting stored in the MemberSetting Gyrobase class for this member.
 * @param {string} setting
 * @param {function(Foundation.Member.Setting)} callback
 */
Foundation.Member.prototype.fetchSettingObject = function (setting, callback) {
    var path = Foundation.Member.settingPath(setting);
    Foundation.Member.Setting.updateNamespace(this.get("oid"), path.namespace).then(function () {
        var setting = new Foundation.Member.Setting(this.get("oid"), path.namespace, path.name);
        callback(setting);
    }.bind(this))
};

/**
 * @param {string} setting
 * @param {function(string)} callback
 */
Foundation.Member.prototype.fetchSettingValue = function (setting, callback) {
    this.fetchSettingObject(setting, function (setting) {
        callback(setting.value());
        setting.destroy();
    })
};

/**
 * @param {string} settingPath
 * @param {string} value
 */
Foundation.Member.prototype.saveSettingValue = function (settingPath, value) {
    var path = Foundation.Member.settingPath(settingPath);
    var setting = new Foundation.Member.Setting(this.get("oid"), path.namespace, path.name);
    setting.setValue(value);
};

/**
 * @param {string} setting
 * @return {{namespace:string, name:string}}
 */
Foundation.Member.settingPath = function (setting) {
    if (!setting.match(/^\w+\.\w+/)) {
        throw new Error(`Invalid setting name. Expected word.word...: ${setting}`);
    }

    var path = setting.split(/\./);
    var namespace = path.shift();
    var name = path.join(".");

    return {namespace: namespace, name: name};
};

Foundation.Member.prototype["fetchSettingObject"] = Foundation.Member.prototype.fetchSettingObject;
Foundation.Member.prototype["fetchSettingValue"] = Foundation.Member.prototype.fetchSettingValue;
Foundation.Member.prototype["saveSettingValue"] = Foundation.Member.prototype.saveSettingValue;
